import { render, staticRenderFns } from "./ChatLanding.vue?vue&type=template&id=797b6071&"
import script from "./ChatLanding.vue?vue&type=script&lang=ts&"
export * from "./ChatLanding.vue?vue&type=script&lang=ts&"
import style0 from "./ChatLanding.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports